/**
 * Email validation and normalization utilities
 */

/**
 * Validates email format using RFC 5322 standard
 * @param email The email address to validate
 * @returns boolean indicating if email format is valid
 */
export const isValidEmail = (email: string): boolean => {
  if (!email) return false;

  // RFC 5322 compliant email regex
  const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  return emailRegex.test(email);
};

/**
 * Normalizes an email address by converting to lowercase and trimming whitespace
 * @param email The email address to normalize
 * @returns normalized email address
 */
export const normalizeEmail = (email: string): string => {
  return email.toLowerCase().trim();
};

/**
 * Validates and normalizes an email address
 * @param email The email address to validate and normalize
 * @returns object containing validation result and normalized email
 */
export const validateAndNormalizeEmail = (
  email: string
): {
  isValid: boolean;
  normalizedEmail: string;
} => {
  const normalizedEmail = normalizeEmail(email);
  return {
    isValid: isValidEmail(normalizedEmail),
    normalizedEmail,
  };
};
